import { CustomFieldModel } from "../document/custom-field-model";
/**
 * This class is used for when a Myfile has subgroups based on names, sed on names, to easily separate those subgroups from the main Array into subarrays that can be viewed, while keeping structure.
 * Give in that the @subGroupName is the same in the myfile they will be added to this @group . 
 */
export class CustomFieldSubGroupModel{
    subGroupName?: string;
    group: CustomFieldModel[] = [];
}
